class News {
    public id: number;
    public title: string;
    public content: string;
    public image : string;
    public url : string;
    public created_at:string
    public updated_at:string
    public is_active: boolean

    constructor(id: number, title: string, content: string, image : string, url : string, created_at:string, updated_at:string, is_active: boolean) {
        this.id = id;
        this.title = title;
        this.content = content;
        this.image = image;
        this.url = url;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.is_active = is_active;
    }
}
export default News;